import { render, staticRenderFns } from "./MySafety.vue?vue&type=template&id=77077f40&"
import script from "./MySafety.vue?vue&type=script&lang=js&"
export * from "./MySafety.vue?vue&type=script&lang=js&"
import style0 from "./MySafety.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports